import { useMemo } from 'react';
import { IFormConfig, TFormField } from 'js/components/common/Form/types';

import * as helpers from '../helpers';

export const useFields = ({ formConfig }: Record<'formConfig', IFormConfig | undefined>): TFormField[] => {
    return useMemo(() => {
        if (!formConfig) {
            return [];
        }

        const { formFields } = formConfig;

        return helpers.getFormFields(formFields);
    }, [formConfig]);
};
